module.exports = __webpack_public_path__ + "img/_DSC7512-min.05e75100.jpg";